import React from "react";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Zoom from "react-reveal/Zoom";

import ReactGA from "react-ga4";
import Meeting from "../assets/images/icons/Meeting.png";
import Map from "../assets/images/wifi-signal.png";
import PrintIcon from "../assets/images/printing.png";
import Valet from "../assets/images/icons/Valet.png";
import { useTranslation } from "react-i18next";
import { isClosedNow } from "../utils/availability";
import managementIcon from "./../assets/images/management.png";
import interiorDesignIcon from "./../assets/images/interior-design.png";
import G2 from "../../src/assets/images/icons/g2.png";
import G3 from "../../src/assets/images/icons/g3.png";
function MenuList({
  services,
  loading,
  has_extra_services,
  show_wifi_access,
  show_printing_service,
  guest_directory_service,
}) {
  // console.log("guest directoyr", guest_directory_service);
  const { t, i18n } = useTranslation();

  // console.log("has_extra_services",has_extra_services);
  const [showClass, setShowClass] = useState(true);
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const businessType = localStorage.getItem("businessType");
  const business_name = localStorage.getItem("business_name");
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowClass(true);
  //   }, 3000);

  //   return () => clearTimeout(timer);
  // }, []);

  const routes = {
    Laundry: `/${room_uuid}/Laundry`,
    "Food Orders": `/${room_uuid}/Restaurants`,
    "In Room Dining": `/${room_uuid}/Restaurants`,
    "Restaurant Booking": `/${room_uuid}/RestaurantBooking `,
    Pharmacy: `/${room_uuid}/Pharmacy`,
    Flowers: `/${room_uuid}/Flowers`,
    "Car Rental": `/${room_uuid}/CarRental`,
    Housekeeping: `/${room_uuid}/HouseKeeping`,
    Entertainment: `/${room_uuid}/Entertainment`,
    "Healthcare & Wellness": `/${room_uuid}/Healthcare`,
    "Salon at Home": `/${room_uuid}/SalonAtHome`,
    Spa: `/${room_uuid}/Spa`,
    "HH Taxi Booking": `/${room_uuid}/HHTaxi`,
    "Taxi Booking": `/${room_uuid}/Taxi`,
    "Concierge Services": `/${room_uuid}/Concierge`,
  };
  const lang = sessionStorage.getItem("lang");

  const changeRoute = (link, serviceId) => {
    if (serviceId == 1) {
      return `${room_uuid}/restaurant/categories/10`;
    }
    if (link.includes("kit")) {
      return `${room_uuid}/restaurant/categories/10`;
    }
    // if (link.includes("hh-house-keeping-companies")) {
    //   console.log("house_keeping");
    //   return `${room_uuid}/house_keeping`;
    // }
    return link;
  };

  let color = localStorage.getItem("color");
  const serviceOrder = [
    "Concierge",
    "Atelier",
    "Property Management",
    "Maintenance",
    "Media",
    "Restaurant Booking",
    "In Room Dining",
    "Laundry",
    "HH HouseKeeping",
  ];
  // You can have a function to reorder the services before rendering
  function getOrderedServices(services) {
    const copyServices = structuredClone(services);

    if (business_name === "The Lana Residences Dubai") {
      const staticServices = [
        {
          id: 81212,
          business_type_id: 1,
          icon: managementIcon,
          service_name: "Property Management",
          is_closed: false,
          is_hidden: false,
          display_name: "Property Management",
          link: `${room_uuid}/pdf-viewer?pdf=${encodeURIComponent(
            "https://tdhbucket.s3.me-central-1.amazonaws.com/lana_pdfs/LIV_PM.pdf"
          )}&name=Property Management`,
          created_at: "2024-07-15T09:17:03.000000Z",
          updated_at: "2024-07-15T09:17:03.000000Z",
        },
        {
          id: 81214,
          business_type_id: 1,
          icon: interiorDesignIcon,
          service_name: "Atelier",
          is_closed: false,
          is_hidden: false,
          display_name: "Atelier",
          link: `${room_uuid}/pdf-viewer?pdf=${encodeURIComponent(
            "https://tdhbucket.s3.me-central-1.amazonaws.com/lana_pdfs/Omniyat+Atelier+Brochure.pdf"
          )}&name=Atelier`,
          created_at: "2024-07-15T09:17:03.000000Z",
          updated_at: "2024-07-15T09:17:03.000000Z",
        },
      ];

      // Combine static and dynamic services only for Lana Residences
      const combinedServices = [...copyServices, ...staticServices];

      // Apply ordering only for Lana Residences
      return combinedServices.sort((a, b) => {
        const indexA = serviceOrder.indexOf(a.service_name);
        const indexB = serviceOrder.indexOf(b.service_name);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        return indexA !== -1 ? -1 : indexB !== -1 ? 1 : 0;
      });
    }

    // For other businesses, return services without modification
    return copyServices;
  }
  return (
    <>
      <ul
        className={
          loading
            ? `animated-background bg-skimmer menu-list ${
                businessType == "Hospital" ? "jsc" : ""
              }`
            : `menu-list ${businessType == "Hospital" ? "jsc" : ""}`
        }
      >
        {guest_directory_service && (
          <>
            <li>
              <Zoom>
                <Link
                  id="trans-anime"
                  className={`trans closed  `}
                  // to={routes[service.service_name]}
                  to={`/${room_uuid}/guestDirectory`}
                >
                  <div className="img-pnl  position-relative ">
                    <div className="closed-tag"></div>
                    <img src={G2} style={{ width: "30px", height: "30x" }} />

                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                      style={{
                        borderRadius: "50%",
                        left: "-5px",
                        top: "-5px",
                        bottom: "-5px",
                        right: "-5px",
                      }}
                    ></div>
                  </div>
                  <div className="txt-pnl position-relative">
                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                    ></div>
                    <p className=""> {t("House Manual")}</p>
                  </div>
                </Link>
              </Zoom>
            </li>
          </>
        )}
        {business_name == "The Lana Residences Dubai"
          ? getOrderedServices(services).map((service, idx) => (
              <li
                key={idx}
                onClick={() => {
                  if (service.id == 33) {
                    console.log("clicked");
                    // window.location.href = service.link;
                    window.open(service.link, "_blank");
                    return;
                  }
                  if (
                    service.id == 11 &&
                    business_name?.toLowerCase() ==
                      "Lakeview Hotel and Apartments"
                  ) {
                    window.open(
                      "https://www.instagram.com/mansiflowershop",
                      "_blank"
                    );
                    return;
                  }
                }}
              >
                <Zoom>
                  <Link
                    id="trans-anime"
                    className={`trans closed ${
                      isClosedNow(service) && "services-option"
                    } `}
                    onClick={(e) => {
                      if (isClosedNow(service)) e.preventDefault();
                    }}
                    // to={routes[service.service_name]}
                    to={
                      !isClosedNow(service) &&
                      service.id !== 33 &&
                      (service.id == -2
                        ? `/${room_uuid}/boat-booking`
                        : `/${changeRoute(service.link, service.id)}`)
                    }
                    state={{ service: service }}
                  >
                    <div className="img-pnl  position-relative ">
                      <div className="closed-tag"></div>
                      <img
                        src={service.icon}
                        className=""
                        style={
                          service.id == 24
                            ? { width: "60px" }
                            : { width: "45px" }
                        }
                        alt="In-Room Dining"
                      />
                      <div
                        className={
                          !showClass ? "animated-background bg-skimmer" : ""
                        }
                        style={{
                          borderRadius: "50%",
                          left: "-5px",
                          top: "-5px",
                          bottom: "-5px",
                          right: "-5px",
                        }}
                      ></div>
                    </div>
                    <div className="txt-pnl position-relative">
                      <div
                        className={
                          !showClass ? "animated-background bg-skimmer" : ""
                        }
                      ></div>

                      <p className="">
                        {lang == "AR" && service.id == 21
                          ? service.service_name
                          : business_name === "JA Beach Resort Demo" &&
                            service.display_name === "In Room Dining"
                          ? "F&B"
                          : service.display_name}
                      </p>
                    </div>
                  </Link>
                </Zoom>
              </li>
            ))
          : services?.map((service, idx) => {
              return (
                <li
                  key={idx}
                  onClick={() => {
                    ReactGA.event({
                      category: "Click on Service",
                      action: "Click",
                      value: `service name: ${service.display_name}}`,
                    });
                  }}
                >
                  <Zoom>
                    <Link
                      id="trans-anime"
                      className={`trans closed ${
                        isClosedNow(service) && "services-option"
                      } `}
                      onClick={(e) => {
                        if (isClosedNow(service)) {
                          e.preventDefault();
                          return;
                        }
                        if (service.id == 33) {
                          console.log("clicked");
                          window.open(service.link, "_blank");
                          return;
                        }
                        if (
                          service.id == 11 &&
                          business_name?.toLowerCase() ===
                            "lakeview hotel and apartments"
                        ) {
                          window.open(
                            "https://www.instagram.com/mansiflowershop",
                            "_blank"
                          );
                          return;
                        }
                      }}
                      // to={routes[service.service_name]}
                      to={
                        !isClosedNow(service) &&
                        service.id !== 33 &&
                        !(
                          service.id == 11 &&
                          business_name?.toLowerCase() ===
                            "lakeview hotel and apartments"
                        ) &&
                        (service.id == -2
                          ? `/${room_uuid}/boat-booking`
                          : `/${changeRoute(service.link, service.id)}`)
                      }
                      state={{ service: service }}
                    >
                      <div className="img-pnl  position-relative ">
                        <div className="closed-tag"></div>
                        <img
                          src={service.icon}
                          className=""
                          style={
                            service.id == 24
                              ? { width: "60px" }
                              : { width: "45px" }
                          }
                          alt="In-Room Dining"
                        />
                        <div
                          className={
                            !showClass ? "animated-background bg-skimmer" : ""
                          }
                          style={{
                            borderRadius: "50%",
                            left: "-5px",
                            top: "-5px",
                            bottom: "-5px",
                            right: "-5px",
                          }}
                        ></div>
                      </div>
                      <div className="txt-pnl position-relative">
                        <div
                          className={
                            !showClass ? "animated-background bg-skimmer" : ""
                          }
                        ></div>

                        <p className="">
                          {lang == "AR" && service.id == 21
                            ? service.service_name
                            : business_name === "JA Beach Resort Demo" &&
                              service.display_name === "In Room Dining"
                            ? "F&B"
                            : service.display_name}
                        </p>
                      </div>
                    </Link>
                  </Zoom>
                </li>
              );
            })}

        {/* <li
          onClick={() => {
            ReactGA.event({
              category: "Click on Service",
              action: "Click",
              value: `service name: Things To Do`,
            });
          }}
        >
          <Zoom>
            <Link
              id="trans-anime"
              // to={routes[service.service_name]}
              to={`/${changeRoute("things-to-do")}`}
            >
              <div className="img-pnl  position-relative ">
                <div className="closed-tag"></div>
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/business_services/17.png"
                  }
                  className=""
                  style={{ width: "45px" }}
                  alt="In-Room Dining"
                />
                <div
                  className={!showClass ? "animated-background bg-skimmer" : ""}
                  style={{
                    borderRadius: "50%",
                    left: "-5px",
                    top: "-5px",
                    bottom: "-5px",
                    right: "-5px",
                  }}
                ></div>
              </div>
              <div className="txt-pnl position-relative">
                <div
                  className={!showClass ? "animated-background bg-skimmer" : ""}
                ></div>

                <p className="">Things To Do</p>
              </div>
            </Link>
          </Zoom>
        </li> */}
        {/* <li key={"Stationary"}>
          <Zoom>
            <Link
              id="trans-anime"
              className={`trans closed  `}
              // to={routes[service.service_name]}
              to={`/${room_uuid}/things-to-do`}
            >
              <div className="img-pnl  position-relative ">
                <div className="closed-tag"></div>
                <img
                  src={Map}
                  className=""
                  style={{ width: "45px" }}
                  alt="In-Room Dining"
                />
                <div
                  className={!showClass ? "animated-background bg-skimmer" : ""}
                  style={{
                    borderRadius: "50%",
                    left: "-5px",
                    top: "-5px",
                    bottom: "-5px",
                    right: "-5px",
                  }}
                ></div>
              </div>
              <div className="txt-pnl position-relative">
                <div
                  className={!showClass ? "animated-background bg-skimmer" : ""}
                ></div>

                <p className=""> {t("Things To Do")}</p>
              </div>
            </Link>
          </Zoom>
        </li> */}
        {show_wifi_access && (
          <>
            <li key={"show_wifi_access"}>
              <Zoom>
                <Link
                  id="trans-anime"
                  className={`trans closed  `}
                  // to={routes[service.service_name]}
                  to={`/${room_uuid}/wifi-access`}
                >
                  <div className="img-pnl  position-relative ">
                    <div className="closed-tag"></div>

                    <img
                      src={Map}
                      className=""
                      style={{ width: "45px" }}
                      alt="In-Room Dining"
                    />
                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                      style={{
                        borderRadius: "50%",
                        left: "-5px",
                        top: "-5px",
                        bottom: "-5px",
                        right: "-5px",
                      }}
                    ></div>
                  </div>
                  <div className="txt-pnl position-relative">
                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                    ></div>

                    <p className=""> {t("Wi-Fi Access")}</p>
                  </div>
                </Link>
              </Zoom>
            </li>
          </>
        )}
        {show_printing_service && (
          <>
            <li key={"show_printing_service"}>
              <Zoom>
                <Link
                  id="trans-anime"
                  className={`trans closed  `}
                  // to={routes[service.service_name]}
                  to={`/${room_uuid}/printing-service`}
                >
                  <div className="img-pnl  position-relative ">
                    <div className="closed-tag"></div>
                    <img
                      src={PrintIcon}
                      className=""
                      style={{ width: "45px" }}
                      alt="In-Room Dining"
                    />
                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                      style={{
                        borderRadius: "50%",
                        left: "-5px",
                        top: "-5px",
                        bottom: "-5px",
                        right: "-5px",
                      }}
                    ></div>
                  </div>
                  <div className="txt-pnl position-relative">
                    <div
                      className={
                        !showClass ? "animated-background bg-skimmer" : ""
                      }
                    ></div>
                    <p className=""> {t("Printing")}</p>
                  </div>
                </Link>
              </Zoom>
            </li>
          </>
        )}

        <>
          <li>
            <Zoom>
              <Link
                id="trans-anime"
                className={`trans closed  `}
                // to={routes[service.service_name]}
                to={`/${room_uuid}/Feedback`}
              >
                <div className="img-pnl  position-relative ">
                  <div className="closed-tag"></div>
                  <img
                    src={G3}
                    alt=""
                    style={{ maxWidth: "40px", maxHeight: "40px" }}
                  />
                  <div
                    className={
                      !showClass ? "animated-background bg-skimmer" : ""
                    }
                    style={{
                      borderRadius: "50%",
                      left: "-5px",
                      top: "-5px",
                      bottom: "-5px",
                      right: "-5px",
                    }}
                  ></div>
                </div>
                <div className="txt-pnl position-relative">
                  <div
                    className={
                      !showClass ? "animated-background bg-skimmer" : ""
                    }
                  ></div>

                  <p className=""> {t("Guest Review")}</p>
                </div>
              </Link>
            </Zoom>
          </li>
          {/* <li>
            <Zoom>
              <Link
                id="trans-anime"
                className={`trans closed  `}
                // to={routes[service.service_name]}
                to={`/${room_uuid}/menu`}
              >
                <div className="img-pnl  position-relative ">
                  <div className="closed-tag"></div>
                  <svg
                    width="34"
                    height="34"
                    viewBox="0 0 24 24"
                    fill={color}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M20.75 7C20.75 7.19891 20.671 7.38968 20.5303 7.53033C20.3897 7.67098 20.1989 7.75 20 7.75H4C3.80109 7.75 3.61032 7.67098 3.46967 7.53033C3.32902 7.38968 3.25 7.19891 3.25 7C3.25 6.80109 3.32902 6.61032 3.46967 6.46967C3.61032 6.32902 3.80109 6.25 4 6.25H20C20.1989 6.25 20.3897 6.32902 20.5303 6.46967C20.671 6.61032 20.75 6.80109 20.75 7ZM20.75 12C20.75 12.1989 20.671 12.3897 20.5303 12.5303C20.3897 12.671 20.1989 12.75 20 12.75H4C3.80109 12.75 3.61032 12.671 3.46967 12.5303C3.32902 12.3897 3.25 12.1989 3.25 12C3.25 11.8011 3.32902 11.6103 3.46967 11.4697C3.61032 11.329 3.80109 11.25 4 11.25H20C20.1989 11.25 20.3897 11.329 20.5303 11.4697C20.671 11.6103 20.75 11.8011 20.75 12ZM20.75 17C20.75 17.1989 20.671 17.3897 20.5303 17.5303C20.3897 17.671 20.1989 17.75 20 17.75H4C3.80109 17.75 3.61032 17.671 3.46967 17.5303C3.32902 17.3897 3.25 17.1989 3.25 17C3.25 16.8011 3.32902 16.6103 3.46967 16.4697C3.61032 16.329 3.80109 16.25 4 16.25H20C20.1989 16.25 20.3897 16.329 20.5303 16.4697C20.671 16.6103 20.75 16.8011 20.75 17Z"
                      fill="#fff"
                    />
                  </svg>
                  <div
                    className={
                      !showClass ? "animated-background bg-skimmer" : ""
                    }
                    style={{
                      borderRadius: "50%",
                      left: "-5px",
                      top: "-5px",
                      bottom: "-5px",
                      right: "-5px",
                    }}
                  ></div>
                </div>
                <div className="txt-pnl position-relative">
                  <div
                    className={
                      !showClass ? "animated-background bg-skimmer" : ""
                    }
                  ></div>
                  <p className=""> {t("More")}</p>
                </div>
              </Link>
            </Zoom>
          </li> */}
        </>

        {/*  <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Restaurants"
          >
            <div className="img-pnl ">
              <img src={InRoomDining} alt="In-Room Dining" />
            </div>
            <div className="txt-pnl">
              <p className="">In-Room Dining</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/RestaurantBooking"
          >
            <div className="img-pnl">
              <img src={RestaurantBooking} alt="Restaurant Booking" />
            </div>
            <div className="txt-pnl">
              <p>Restaurant Booking</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Laundry"
          >
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/8.png"
                }
                className="restaurant-icon"
                alt="Laundry"
              />
            </div>
            <div className="txt-pnl">
              <p>Laundry</p>
            </div>
          </Link>
        </li>
        <li>
          <Link id="trans-anime" className={showClass ? "trans" : ""} to="/Spa">
            <div className="img-pnl">
              <img src={Spa} alt="SPA" />
            </div>
            <div className="txt-pnl">
              <p>SPA</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/HouseKeeping"
          >
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/6.png"
                }
                className="restaurant-icon"
                alt="Housekeeping"
              />
            </div>
            <div className="txt-pnl">
              <p>Housekeeping</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Concierge"
          >
            <div className="img-pnl">
              <img src={ConciergeServices} alt="Concierge Services" />
            </div>
            <div className="txt-pnl">
              <p>Concierge Services</p>
            </div>
          </Link>
        </li>
        <li>
          <Link id="trans-anime" className={showClass ? "trans" : ""} to="/">
            <div className="img-pnl">
              <img src={Supermarket} alt="Supermarket" />
            </div>
            <div className="txt-pnl">
              <p>Supermarket</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Pharmacy"
          >
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/2.png"
                }
                className="restaurant-icon"
                alt="Pharmacy"
              />
            </div>
            <div className="txt-pnl">
              <p>Pharmacy</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Flowers"
          >
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/1.png"
                }
                className="restaurant-icon"
                alt="Flowers"
              />
            </div>
            <div className="txt-pnl">
              <p>Flowers</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/CarRental"
          >
            <div className="img-pnl">
              <img src={CarRental} alt="Car Rental" />
            </div>
            <div className="txt-pnl">
              <p>Car Rental</p>
            </div>
          </Link>
        </li>
        <li>
          <Link id="trans-anime" className={showClass ? "trans" : ""} to="/">
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/15.png"
                }
                className="restaurant-icon"
                alt="Supermarket"
              />
            </div>
            <div className="txt-pnl">
              <p>Maintenance Services</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Entertainment"
          >
            <div className="img-pnl">
              <img src={Entertainment} alt="Entertainment" />
            </div>
            <div className="txt-pnl">
              <p>Entertainment</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Healthcare"
          >
            <div className="img-pnl">
              <img
                src={
                  "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/17.png"
                }
                className="restaurant-icon"
                alt="Supermarket"
              />
            </div>
            <div className="txt-pnl">
              <p>Healthcare & Wellness</p>
            </div>
          </Link>
        </li>
        <li>
          <Link
            id="trans-anime"
            className={showClass ? "trans" : ""}
            to="/Taxi"
          >
            <div className="img-pnl">
              <img src={Taxi} alt="Taxi Booking" />
            </div>
            <div className="txt-pnl">
              <p>Taxi Booking</p>
            </div>
          </Link>
        </li> */}
      </ul>
    </>
  );
}
export default MenuList;
